import React from "react";
import { CurrentPathProvider } from "../../contexts";
import { ThemeProvider } from "../../components/theme/ThemeProvider";
import { AppToastProvider } from "../../components/feedback/AppToastProvider";
import FlashToaster from "../../components/feedback/FlashToaster";
import { AppHeader } from "../../components/layout/AppHeader";
import { AdminLayout } from "../../components/layout/AdminLayout";
import {
  AdminOverviewPage,
  AdminAccountsPage,
  AdminOrganizationsPage,
  AdminOrganizationDetailPage,
  AdminUserDetailPage,
  AdminBlogIndexPage,
  AdminBlogNewPage,
  AdminBlogEditPage,
  AdminJobsPage,
} from "./components";
import type { AdminAppPageProps } from "./types";

export const AdminAppPage: React.FC<AdminAppPageProps> = (props) => {
  const adminDateOptions = {
    locale: props.i18nLocale,
    timeZone: props.appTimeZone,
  };

  return (
    <ThemeProvider>
      <CurrentPathProvider currentPath={props.currentPath}>
        <AppToastProvider>
          <FlashToaster flash={props.flash} />
          <div className="ds-shell">
            <AppHeader
              variant="app"
              loggedIn={props.loggedIn}
              hasBusiness={props.hasBusiness}
              routes={props.routes}
              csrfToken={props.csrfToken}
              page={props.page}
              unreadQuoteCount={0}
              userDisplay={props.userDisplay}
              admin
              adminPath={props.adminPath}
              adminRoutes={props.adminRoutes}
              isAdminContext
            />

            <AdminLayout routes={props.adminRoutes}>
              {props.page === "overview" && props.overview && (
                <AdminOverviewPage overview={props.overview} />
              )}
              {props.page === "organizations" && props.organizations && (
                <AdminOrganizationsPage
                  organizations={props.organizations}
                  unassignedUsers={props.unassignedUsers ?? []}
                  dateOptions={adminDateOptions}
                  adminRoutes={props.adminRoutes}
                />
              )}
              {props.page === "organizationDetail" &&
                props.organizationDetail &&
                props.billingStatusOptions && (
                  <AdminOrganizationDetailPage
                    detail={props.organizationDetail}
                    billingStatusOptions={props.billingStatusOptions}
                    dateOptions={adminDateOptions}
                    csrfToken={props.csrfToken}
                    currentUserId={props.currentUserId}
                    adminRoutes={props.adminRoutes}
                  />
                )}
              {props.page === "users" && props.accounts && (
                <AdminAccountsPage
                  accounts={props.accounts}
                  dateOptions={adminDateOptions}
                  adminRoutes={props.adminRoutes}
                />
              )}
              {props.page === "userDetail" &&
                props.accountDetail &&
                props.billingStatusOptions && (
                  <AdminUserDetailPage
                    detail={props.accountDetail}
                    billingStatusOptions={props.billingStatusOptions}
                    dateOptions={adminDateOptions}
                    csrfToken={props.csrfToken}
                    currentUserId={props.currentUserId}
                    adminRoutes={props.adminRoutes}
                  />
                )}
              {props.page === "blogIndex" && (
                <AdminBlogIndexPage
                  posts={props.blogPosts ?? []}
                  adminRoutes={props.adminRoutes}
                  dateOptions={adminDateOptions}
                />
              )}
              {props.page === "blogNew" && (
                <AdminBlogNewPage
                  adminRoutes={props.adminRoutes}
                  csrfToken={props.csrfToken}
                  tradeOptions={props.tradeOptions ?? []}
                  lengthOptions={props.lengthOptions ?? []}
                />
              )}
              {props.page === "blogEdit" && props.blogPost && (
                <AdminBlogEditPage
                  post={props.blogPost}
                  adminRoutes={props.adminRoutes}
                  csrfToken={props.csrfToken}
                  tradeOptions={props.tradeOptions ?? []}
                />
              )}
              {props.page === "jobs" && props.jobsData && (
                <AdminJobsPage
                  jobsData={props.jobsData}
                  adminRoutes={props.adminRoutes}
                  csrfToken={props.csrfToken}
                />
              )}
            </AdminLayout>
          </div>
        </AppToastProvider>
      </CurrentPathProvider>
    </ThemeProvider>
  );
};
